// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"icon-wrapper--Q_g1x","iconWrapper":"icon-wrapper--Q_g1x","icon":"icon--nMQEo","active":"active--VrD9g","name":"name--vQl_s"};